import React, { useEffect, useState } from "react";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";
import "../App.css";
import qa from "../image/qa.jpg";
import clinicalData from "../image/clinicalData.jpg";
import due from "../image/due.jpg";
import hmis from "../image/hmis.jpg";
import hr from "../image/hr.jpg";
import medicalEquipment from "../image/medicalEquipment.jpg";
import nabh from "../image/nabh.jpg";
import medicalValue from "../image/medicalValue.jpg";
import best from "../image/best.jpg";
import hiring from "../image/hiring.jpg";
import flexibility from "../image/flexibility.jpg";
import Plant_1 from "../image/Plant-1.jpg";
import Plant_2 from "../image/Plant-2.jpg";
import Plant_3 from "../image/Plant-3.jpg";

import JoinUs from "./JoinUs";
import FramedImage from "./FramedImage";

function Dashboard() {
  const [hasVideoSection, setHasVideoSection] = useState(false);
  const [visibleImages, setVisibleImages] = useState([]);

  useEffect(() => {
    const images = [Plant_2, Plant_3];
    let index = 0;
    const interval = setInterval(() => {
      setVisibleImages([images[index]]);
      index = (index + 1) % images.length;
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setHasVideoSection(
      !!document.querySelector(".dashboard-background .video-container")
    );
  }, []);

  return (
    <div>
      <div
        className="dashboard-background"
        style={{
          padding: hasVideoSection ? "20px" : "0px",
          overflow: "hidden",
        }}
      >
        <div className="hero-container">
          <div className="image-section">
            <img src={Plant_1} alt="Main Plant" className="hero-image" />

            {/* Floating Frames for Plant_2 & Plant_3 */}
            <div className="floating-frame frame-top-right">
              <img src={Plant_2} alt="Plant 2" className="frame-image" />
            </div>
            <div className="floating-frame frame-bottom-left">
              <img src={Plant_3} alt="Plant 3" className="frame-image" />
            </div>
          </div>

          <div className="text-section">
            <h1>
              "Empowering healthcare organisations to deliver exceptional
              patient care."
            </h1>
            <p className="hide-on-small">
              Innovating healthcare for a healthier tomorrow.Taking care of your
              Health is our Top Priority
            </p>
          </div>
        </div>

        <div className="information-section flex flex-column align-items-center text-center">
          <div>
            <h1>What Are We For ?</h1>
            <p>
              Welcome to{" "}
              <span className="dashboard-imp">Tarushi Healthcare</span>, where
              we empower healthcare organizations to deliver exceptional patient
              care. Our tools, guidance, and support will help you succeed in
              your respective market. Take a look around and explore how we can
              help you achieve your goals.
            </p>
          </div>
        </div>

        <div className="information-section">
          <h1>Our Services</h1>

          <div className="grid p-5">
            {[
              { src: qa, title: "Quality Assurance" },
              { src: nabh, title: "NABH Accreditation" },
              { src: hmis, title: "HMIS" },
              { src: due, title: "Due Diligence" },
              { src: clinicalData, title: "Clinical Data Management" },
              { src: medicalValue, title: "Medical Value Travel" },
              { src: medicalEquipment, title: "Biomedical Equipment" },
              { src: hr, title: "HR Recruitment" },
            ].map((service, index) => (
              <div
                key={index}
                className="col-12 md:col-3 flex flex-column align-items-center text-center"
              >
                <div className="service-card">
                  <img
                    src={service.src}
                    alt={service.title}
                    className="service-image border-round shadow-3"
                    loading="lazy"
                  />
                  <p className="service-title">{service.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="why-choose-us-container text-center p-5">
          <h1 className="mb-4">Why Choose Us?</h1>
          <div className="flex flex-column gap-5">
            {[
              {
                src: hiring,
                title: "Better Hiring Process",
                description:
                  "We streamline the hiring process to save you time and find the best talent. By leveraging advanced screening methods and AI-driven insights, we ensure you connect with candidates who align with your company culture and long-term goals. Our structured approach minimizes hiring risks and maximizes success.",
              },
              {
                src: flexibility,
                title: "Increased Flexibility",
                description:
                  "Our approach adapts to your business needs, ensuring flexibility and efficiency. Whether you're scaling up, restructuring, or implementing new strategies, we offer dynamic solutions tailored to your objectives. Our agile framework allows you to pivot quickly and stay ahead in a rapidly changing market.",
              },
              {
                src: best,
                title: "We Are the Best in the Industry",
                description:
                  "With years of experience, we provide top-tier services to our clients. Our commitment to excellence, innovative solutions, and customer-first approach set us apart. We continuously refine our strategies, integrate the latest industry trends, and maintain a track record of delivering exceptional results for businesses of all sizes.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`flex flex-wrap md:flex-nowrap items-center mb-2 ${
                  index % 2 === 0 ? "flex-row-reverse" : ""
                }`}
              >
                <FramedImage img={item.src} isVisible={true} />
                <div className="w-full md:w-1/2 p-5 text-left">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <JoinUs />
      </div>
    </div>
  );
}

export default Dashboard;
